import {CO_PARENT_INVITATION_STORAGE_KEY} from '@/app/main/coparent/constants';
import {ICoparenting} from '@/services/segment/models/TrackingManagerEventModel';

interface CoparentingSchema {
  Coparenting: ICoparenting;
}

export const getCoparentingSchema = (): CoparentingSchema => {
  try {
    return {
      Coparenting: {
        is_coparent_user: !!localStorage.getItem(
          CO_PARENT_INVITATION_STORAGE_KEY,
        ),
      },
    };
  } catch {
    return {
      Coparenting: {
        is_coparent_user: false,
      },
    };
  }
};
